import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Shared by every record drawer: lets the shell shift its content margin and
// lets a table hide its secondary columns while a drawer is open, without
// coupling either to the drawer that happens to be open.
@Injectable({
    providedIn: 'root',
})
export class DrawerStateService {
    private readonly openSubject = new BehaviorSubject<boolean>(false);
    public readonly isOpen$ = this.openSubject.asObservable();

    public setOpen(open: boolean): void {
        this.openSubject.next(open);
    }
}
